import axios from "axios";
import Cookies from "universal-cookie";

// Initialize cookies for token management
const cookies = new Cookies();

// Function to extract subdomain from current URL
const getSubdomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  
  // If hostname is like "demo.techdogcloud.com", return "demo"
  // If hostname is like "localhost" or "techdogcloud.com", return null
  if (parts.length >= 3) {
    return parts[0];
  }
  return null;
};

// Function to build API base URL
const getApiBaseURL = () => {
  // Try runtime config first (injected by Docker at startup)
  if (window.ENV?.REACT_APP_MIDDLEWARE_API_BASE_URL) {
    return window.ENV.REACT_APP_MIDDLEWARE_API_BASE_URL;
  }
  
  // First check if there's a custom API URL in environment variables
  if (process.env.REACT_APP_MIDDLEWARE_API_BASE_URL) {
    return process.env.REACT_APP_MIDDLEWARE_API_BASE_URL;
  }

  const subdomain = getSubdomain();

  if (window.ENV?.REACT_APP_MIDDLEWARE_AUTOMATIC_OLD_API_DOMAIN === 'true' || process.env.REACT_APP_MIDDLEWARE_AUTOMATIC_OLD_API_DOMAIN === 'true') {
    if (subdomain) {
      return `https://api-middleware.${subdomain}.techdogcloud.com/`;
    }

    // Fallback to old domain if no subdomain is found
    return 'https://api-middleware.dev.techdogcloud.com/';
  }

  
  if (subdomain) {
    return `https://api.${subdomain}.unifiedsmb.cloud/`;
  }
  
  // Fallback for development or when no subdomain is found
  return 'https://api.dev.unifiedsmb.cloud/';
};

const getImagesBaseURL = () => {
  if (window.ENV?.REACT_APP_MIDDLEWARE_API_BASE_IMAGE_URL) {
    return getApiBaseURL() + window.ENV.REACT_APP_MIDDLEWARE_API_BASE_IMAGE_URL;
  }

  if (process.env.REACT_APP_MIDDLEWARE_API_BASE_IMAGE_URL) {
    return getApiBaseURL() + process.env.REACT_APP_MIDDLEWARE_API_BASE_IMAGE_URL;
  }

  // Default to storage as base path for images
  return getApiBaseURL() + 'storage/';
};

// Create an Axios instance with dynamic base URL
const middleware = axios.create({
  baseURL: getApiBaseURL(),
  imagesBaseURL: getImagesBaseURL(),
});

// Request interceptor to add the ApiKey header
middleware.interceptors.request.use(config => {
  const token = cookies.get('token', { secure: false });
  if (token) {
    config.headers.ApiKey = token;
  }
  return config;
}, error => {
  // Handle request error
  return Promise.reject(error);
});

// Response interceptor to handle responses
middleware.interceptors.response.use(response => {
  return response;
}, error => {
  // Check if this request should skip interceptor logic
  if (error.config && error.config.skipResponseInterceptor) {
    return Promise.reject(error);
  }
  
  if (!error.response) {
    // Check the error message to differentiate between offline (network error) and server down
    window.dispatchEvent(new CustomEvent('network-error'));
  } else if (error.response && (error.response.status === 401 || error.response.status === 403)) {
    // Dispatch a custom event
    window.dispatchEvent(new CustomEvent('unauthorized-event', {
      detail: {
        inactiveSubscription: error?.response?.data?.subscriptionStatus
      }
    }));
  }
  return Promise.reject(error);
});

export default middleware;